import { Box, Typography } from "@mui/material"
import type { FC } from "react"

import { AP_AGING_BUCKET_TO_LABEL } from "../../constants"
import type { ApAgingReportSearchParams } from "../../types/searchParams"
import { formatApAgingDateRangeChipLabel } from "../../utils"

import { FilterChip } from "@/components/common/Filters/FilterChip"
import { INVOICE_STATUS_LABELS } from "@/screens/Accounting/subfeatures/Invoices/constants/labels"

interface ApAgingFilterChipsProps {
  searchParams: ApAgingReportSearchParams
  onRemove: (keyOrKeys: keyof ApAgingReportSearchParams | (keyof ApAgingReportSearchParams)[], value?: string) => void
}

export const ApAgingFilterChips: FC<ApAgingFilterChipsProps> = ({ searchParams, onRemove }) => {
  const { statuses, agingBuckets = [], dueDateFrom, dueDateTo } = searchParams

  const hasDueDateRange = Boolean(dueDateFrom || dueDateTo)
  const hasActiveFilters = statuses.length > 0 || agingBuckets.length > 0 || hasDueDateRange

  if (!hasActiveFilters) return null

  return (
    <Box data-testid='ap-aging-report.filter-chips' className='flex flex-wrap items-center gap-4'>
      <Typography variant='body1'>Filters:</Typography>

      {statuses.map((status) => (
        <FilterChip
          key={status}
          testId={`ap-aging-report.filter-chips.status-${status}`}
          label={`Status: ${INVOICE_STATUS_LABELS[status]}`}
          onDelete={() => onRemove("statuses", status)}
        />
      ))}

      {agingBuckets.map((bucket) => (
        <FilterChip
          key={bucket}
          testId={`ap-aging-report.filter-chips.aging-bucket-${bucket}`}
          label={`Aging: ${AP_AGING_BUCKET_TO_LABEL[bucket]}`}
          onDelete={() => onRemove("agingBuckets", bucket)}
        />
      ))}

      {hasDueDateRange && (
        <FilterChip
          testId='ap-aging-report.filter-chips.due-date-range'
          label={formatApAgingDateRangeChipLabel(dueDateFrom, dueDateTo)}
          onDelete={() => onRemove(["dueDateFrom", "dueDateTo"])}
        />
      )}
    </Box>
  )
}
